import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/over-ons", label: "Over ons", testId: "nav-over-ons" },
  { to: "/menu", label: "Menu", testId: "nav-menu" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      className="fixed inset-x-0 top-0 z-40 border-b border-[#3E2723]/5 bg-[#F5F1E8]/80 backdrop-blur-md"
      data-testid="main-header"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="header-logo-link"
        >
          <div className="h-14 w-14 md:h-16 md:w-16 overflow-hidden rounded-full bg-white shadow-md">
            <img
              src="/assets/logo-aroma-cubana.jpg"
              alt="Logo Aroma Cubana"
              className="h-full w-full object-cover"
            />
          </div>
          <span className="font-['Fraunces',_serif] text-xl md:text-2xl text-[#3E2723]">
            Aroma Cubana
          </span>
        </Link>

        {/* Desktop navigatie */}
        <nav className="hidden md:flex items-center gap-8 text-base font-semibold text-[#3E2723]/90">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `relative pb-1 transition-all duration-200 ${
                  isActive
                    ? "text-[#3E2723]"
                    : "text-[#3E2723]/90 hover:text-[#3E2723]"
                }`
              }
              data-testid={item.testId}
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute inset-x-0 -bottom-1 h-[2px] rounded-full bg-[#7ED956]" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* Desktop bestelknop */}
        <div className="hidden md:block">
          <span
            className="glf-button inline-flex cursor-pointer items-center justify-center rounded-full bg-[#7ED956] px-4 py-2 text-sm font-semibold text-white hover:bg-[#6ac445]"
            data-glf-cuid="9355d15b-6f1a-4b1c-ad74-8f75ce295108"
            data-glf-ruid="111089d3-19e8-419f-bf42-1843cf64f484"
            data-testid="header-bestel-online-button"
          >
            Bestel online
          </span>
        </div>

        {/* Hamburger knop (mobiel) */}
        <button
          className="md:hidden p-2 text-[#3E2723]"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Open menu"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobiel menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-[#3E2723]/10 bg-[#F5F1E8] px-4 py-4">
          <nav className="flex flex-col gap-4 text-sm font-medium text-[#3E2723]">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  isActive ? "text-[#7ED956]" : ""
                }
              >
                {item.label}
              </NavLink>
            ))}

            {/* Mobiele bestelknop */}
            <span
              className="glf-button mt-2 inline-flex justify-center rounded-full bg-[#7ED956] px-4 py-2 font-semibold text-white"
              data-glf-cuid="9355d15b-6f1a-4b1c-ad74-8f75ce295108"
              data-glf-ruid="111089d3-19e8-419f-bf42-1843cf64f484"
            >
              Bestel online
            </span>
          </nav>
        </div>
      )}

      {/* GloriaFood script – één keer laden */}
      <script
        src="https://www.fbgcdn.com/embedder/js/ewm2.js"
        defer
        async
      ></script>
    </header>
  );
};

export default Header;
